import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel } from "@syncfusion/ej2-angular-grids";
import { timeStamp } from "console";
import { ToastrService } from "ngx-toastr";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { GlobalComponent } from "src/app/global/global.component";
import { GeneralService } from "src/app/service/general.service";
import { GroupPayorMappingDataService } from "./group-payor-mapping-dataService";
import { functionpermission, getPayorMap, savePayorMap } from "./group-payor-mapping-modal";
import { GroupPayorMappingService } from "./group-payor-mapping.service";

@Component({
  selector: "app-group-payor-mapping",
  templateUrl: "./group-payor-mapping.component.html",
  styleUrls: ["./group-payor-mapping.component.scss"],
})
export class GroupPayorMappingComponent implements OnInit {

  //-------------- Main function Initialization ----------------///
  payorMapForm: FormGroup;
  savePayorData: savePayorMap = new savePayorMap();
  getPayorData: getPayorMap = new getPayorMap();
  private onDestroy$: Subject<void> = new Subject<void>();
  /////////////// Grid Initializations////////////////
  public transcMenuFilterettings: object;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public dropdatas: string[] = ['true', 'false'];
  public height = "220px";
  initialPage: PageSettingsModel;
  public filterSettings: object;
  public gridServiceMapping: Observable<DataStateChangeEventArgs>;
  @ViewChild('grid') public grid: GridComponent;
  modalType: string
  isSaveorUpdateBoolean:boolean=false
 
  

  constructor(
    public http: GroupPayorMappingService,
    public httpService: HttpClient,
    public toasterService: ToastrService, private fb: FormBuilder,
    public global: GlobalComponent, public generalservice: GeneralService,
    @Inject(GroupPayorMappingDataService) public getHttp: GroupPayorMappingDataService,
  ) {
    this.gridServiceMapping = getHttp;
    this.payorMapForm = fb.group({

      group: ['', Validators.required],
      ProviderId: ['', Validators.required],
      service: ['', Validators.required],
      Description: [''],
      npi: [''],
      G2id: [''],
      Atypical: [''],
      Payer: ['', Validators.required],
      Waiver: [''],
      CombineClaim: [''],


    })

  }
  fp: functionpermission = new functionpermission()
  ngOnInit(): void {

    this.getGroup();
    this.getRender();
    this.getService();
    this.getServiceMappingData();

    this.filterSettings = {
      type: "Menu",
    };
    this.initialPage = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: 10,
      pageSize: this.pageSizes[0],
      pageSizes: this.pageSizes,
    };
    this.getpermission()
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "Group Payer Service");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.http.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data != null) {
          this.fp = data;

        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }

  CreateOrUpdate(type: string) {
    if (type == 'new') {
      this.savePayorData = new savePayorMap();
      this.modalType = 'new';
    }
    else {
      this.modalType = 'edit';
    }
  }

  reset() {
    this.payorMapForm.reset();
    this.savePayorData = new savePayorMap();
  }

  //-----------------------------------------------------------Grid----------------------------------------------------------------//
  getServiceMappingData() {

    if (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '' && this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {

      this.getHttp.executeTransactionMenu(this.getPayorData);
      let count = 0;
      this.gridServiceMapping.pipe(takeUntil(this.onDestroy$))
        .subscribe((data: any) => {
          count = count + 1;
        });
    }
  }


  isLoadingEditData: boolean = false;

  getDetails(data) {
    this.isLoadingEditData = true;
    this.savePayorData = JSON.parse(JSON.stringify(data));
    this.groupId = data.groupLid;
    this.savePayorData.id = data.id;
    this.isLoadingEditData = false;
    this.getPayerForEdit(data.groupLid, data.payerId);
  }

  //---------------------------------------------------------------------------------------------------------//
  groupList: any = [];
  groupId: any;
  groupofList: any = [];
  groupofListCopy: any = [];
  payerData: any[];
  getserviceData: any = [];
  getdescriptionData: any = [];
  getGroup() {

    let params = new URLSearchParams();
    params.append("ListCode", "PAYER");
    this.http.getGroup(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.groupList = data;
    }
    )
  }

  getRender() {

    let params = new URLSearchParams();
    params.append("ListCode", "RENDERINGPROVIDER");
    this.http.getRender(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.groupofList = this.groupofListCopy = data;
    }
    )
  }

  onGroupChange(groupId: any) {
    if (this.isLoadingEditData) { return; }
    this.savePayorData.payerId = null;
    this.getPayer(groupId);
  }

  getPayerForEdit(groupId: any, selectedPayerId: any) {
    if (!groupId) { return; }
    let params = new URLSearchParams();
    params.append("groupId", groupId);
    this.http.getPayer(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.payerData = data;
      this.savePayorData.payerId = selectedPayerId;
    });
  }

  getPayer(payerId) {
    if (payerId == null || payerId == undefined || payerId == '') {
      return
    }

    let params = new URLSearchParams();
    params.append("groupId", payerId);
    this.http.getPayer(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.payerData = data;
    }
    )
  }

  getService() {
    if (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '' && this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {

      this.http.getService().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.getserviceData = data;
      })
    }
  }

  getDescription(service) {
    if (service == null || service == undefined || service == '') {
      return
    }
    let serviceName = this.getserviceData.find(x => x.Key == service)?.Value;
    if (serviceName.includes("T2025")) {
      this.groupofList = this.groupofList.filter(x => x.lovCode.trim().toUpperCase() == 'COMPANYIDENTIFIER' ||
        x.lovCode.trim().toUpperCase() == 'NOID');
    } else {
      this.groupofList = this.groupofListCopy;
    }

    let params = new URLSearchParams();
    params.append("Id", service);
    this.http.getServiceDescription(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.getdescriptionData = data.serviceDesc;

    })
  }

  refresh() {
    this.savePayorData = new savePayorMap();
    this.getServiceMappingData();
  }

  //------------------------------------------dataChangePayorServiceMapping----------------------------------------------------///
  public dataChangeServiceMapping(payor): void {
    let val = payor.action.requestType.toString();
    if (val != "filterchoicerequest") {
      if ((payor.sorted || []).length) {
        this.getPayorData.orderColumn = payor.sorted[0].name;
        this.getPayorData.orderType =
          payor.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (val == "filtering" && payor.action.action != "clearFilter") {
      console.log("payor.action.currentFilterObject........", payor.action.currentFilterObject);
      console.log("payor.action.action.........", payor.action.action)
      this.getPayorData.value = payor.action.currentFilterObject.value;
      this.getPayorData.field = payor.action.currentFilterObject.field;
      this.getPayorData.matchCase = payor.action.currentFilterObject.matchCase;
      this.getPayorData.operator = payor.action.currentFilterObject.operator;
      // this.getPayorData.type = payor.action.currentFilterObject.type;
      if (this.getPayorData.type == "number") {
        this.getPayorData.value =
          payor.action.currentFilterObject.value.toString();
        this.getPayorData.field = payor.action.currentFilterObject.field;
      }
      if (["atypical", "combineClaim", "waiver"].includes(this.getPayorData.field)) {
        this.getPayorData.type = "boolean";
      }
    } else {
      if (val == "filtering" && payor.action.action == "clearFilter") {
        this.getPayorData.field = "groupName";
        this.getPayorData.matchCase = false;
        this.getPayorData.operator = "contains";
        this.getPayorData.value = "";
        this.getPayorData.type = "string";
      }
    }
    this.getServiceMappingData();

    if (val == "paging" && payor.action.name == "actionBegin") {
      // if (this.arraycol.length != 0) {
      //   if (this.arraycol[0].Question.Pagesize != Q.take) {
      //     this.arraycol[0].Question.Pagesize = Q.take
      //     // this.SaveColumnwidth();
      //   }
      // }
    }
  }

  /// .........................................onActionPayorServiceMapping.....................................................//
  public onActionServiceMapping(payor) {
    this.getPayorData.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.getPayorData.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    if (payor.name == "actionBegin" && payor.requestType == "filterbeforeopen") {
      this.getPayorData.type = payor.columnType;
    }
  }

  showColumns() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }
  //
  //----------------------------------------------------------------Save-------------------------------------------------------------------------//
  SaveGroupPayerMapping() {
    this.isSaveorUpdateBoolean=true;
    let postData: savePayorMap = JSON.parse(JSON.stringify(this.savePayorData));
    postData.id = this.savePayorData.id
    this.http.SaveRecord(postData).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.isSaveorUpdateBoolean=false;
      if (data) {
        if (this.modalType == 'new') {

          this.toasterService.success('Payer service mapping saved successfully!');
          document.getElementById("exampleModalSave").click();
          this.reset();
          setTimeout(() => {

            this.toasterService.clear();

          }, 5000);
        }
        else {
          this.toasterService.success('Payer service mapping updated  successfully!');
          document.getElementById("exampleModalSave").click();
          setTimeout(() => {

            this.toasterService.clear();

          }, 5000);

        }
        this.getServiceMappingData();
      }


    },
      (err: any) => {
        this.isSaveorUpdateBoolean=false;
        if (err) {
          this.toasterService.error(err, 'Error'), 8000;
        }
      })
  }

  //-----------------------------------------------Delete---------------------------------------------------------------------//
  DeletePayorMapping() {
    let params = new URLSearchParams();
    params.append('id', this.savePayorData.id)
    this.http.DeleteRecord(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toasterService.success('Transaction Deleted successfully!');
      document.getElementById("deleteModal").click();
      this.getServiceMappingData();
    },
      (err: any) => {
        if (err) {
          this.toasterService.error(err, 'Error'), 8000;
        }
      });
  }




}

